import { CitiesContainer } from "../containers/cities"

export const Cities = () => {
    return (
        <CitiesContainer />
    )
}